import { showErrorToast } from "src/components/AlertToastify/AlertToastify";
import { mobile } from "src/utils/platformUtils";

export const getYahooAuthUrl = async (accessAuthToken: string): Promise<any> => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_URL}/get-yahoo-auth-url?platform=${mobile ? "mobile" : "web"}`;
    console.log("🔗 Requesting Yahoo auth URL from:", url);

    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessAuthToken}`,
      },
      credentials: "include",
    });

    if (!response.ok) {
      throw new Error(`Request failed with status ${response.status}`);
    }

    const data = await response.json();
    console.log("📥 Yahoo auth URL response:", {
      url: data.responseData.authUrl,
      platform: mobile ? "mobile" : "web",
    });

    // Asegurarse de que devolvemos la URL en el formato correcto
    return {
      authUrl: data.responseData.authUrl,
    };
  } catch (error) {
    console.error("❌ Error getting Yahoo auth URL:", error);
    showErrorToast("Error getting Yahoo authentication URL");
    throw error;
  }
};
